export default __webpack_public_path__ + "34b12541c986e1e33c6f7ae695630023.jpg";